module.exports = __webpack_public_path__ + "static/media/time.58ff0572.svg";